import React from "react";
import PropTypes from "prop-types";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../../contexts/ThemeContext";
import styles from "./ThemeToggle.module.css";

const ThemeToggle = ({ className = "" }) => {
  const { toggleTheme, isLight } = useTheme();

  const handleToggle = () => {
    toggleTheme();

    // Announce theme change to screen readers
    const announcement = document.createElement("div");
    announcement.setAttribute("aria-live", "polite");
    announcement.setAttribute("aria-atomic", "true");
    announcement.textContent = `Switched to ${isLight ? "dark" : "light"} theme`;
    announcement.style.position = "absolute";
    announcement.style.left = "-10000px";
    document.body.appendChild(announcement);
    setTimeout(() => document.body.removeChild(announcement), 1000);
  };

  return (
    <button
      onClick={handleToggle}
      className={`${styles.themeToggle} ${className}`}
      aria-label={`Switch to ${isLight ? "dark" : "light"} mode`}
      aria-describedby="theme-toggle-help"
      title={`Switch to ${isLight ? "dark" : "light"} mode`}
      role="switch"
      aria-checked={!isLight}
      type="button"
    >
      <div className={styles.iconContainer} aria-hidden="true">
        <Sun
          className={`${styles.icon} ${styles.sunIcon} ${isLight ? styles.active : ""}`}
          aria-hidden="true"
        />
        <Moon
          className={`${styles.icon} ${styles.moonIcon} ${!isLight ? styles.active : ""}`}
          aria-hidden="true"
        />
      </div>
      <span id="theme-toggle-help" className="sr-only">
        Toggle between light and dark theme. Currently using{" "}
        {isLight ? "light" : "dark"} theme.
      </span>
    </button>
  );
};

export default ThemeToggle;

ThemeToggle.propTypes = {
  className: PropTypes.string,
};
